import { useListSeasonPassesQuery } from 'products/reduxApi'
import React, { useMemo } from 'react'
import { MultiSelectCombobox } from 'uiComponents/combobox/combobox'
import { FormItem, FormItemName } from 'uiComponents/form/formElements'
import './upgradeFrom.scss'
import { useTranslation } from 'translations'

interface UpgradeFromProps {
    value: string[]
    onChange: (value: string[]) => void
}

export const UpgradeFrom = ({ value, onChange }: UpgradeFromProps) => {
    const { t } = useTranslation()
    const { data: productOptionsData } = useListSeasonPassesQuery()
    const productOptions = useMemo(() => {
        return (
            productOptionsData?.map((product) => ({
                value: product.id.toString(),
                label: product.name,
            })) || []
        )
    }, [productOptionsData])

    return (
        <FormItem htmlFor="upgrade-from">
            <FormItemName>{t('products.crud.upgradeFrom.label')}</FormItemName>
            <MultiSelectCombobox
                id="upgrade-from"
                value={value}
                onChange={onChange}
                options={productOptions}
                searchPlaceholder={t('products.crud.upgradeFrom.searchPlaceholder')}
                limitTags={10}
            />
            <div className="upgrade-from-explanation">
                <div>{t('products.crud.upgradeFrom.explanation')}</div>
                <div>{t('products.crud.upgradeFrom.explanationPrefill')}</div>
            </div>
        </FormItem>
    )
}
